import { createFileRoute, redirect } from '@tanstack/react-router'
import { session$ } from '@/features/auth/store'
import { resolveAuthRedirect } from '@/features/auth/domain/auth'
import { OnboardingPage } from '@/features/auth/ui/onboarding/onboarding-page'

export const Route = createFileRoute('/onboarding')({
	beforeLoad: () => {
		const to = resolveAuthRedirect(session$.get(), '/onboarding')
		if (to) throw redirect({ to })
	},
	component: Onboarding,
})

function Onboarding() {
	const navigate = Route.useNavigate()
	return <OnboardingPage onComplete={() => navigate({ to: '/' })} />
}
